import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
`;

export const Tiles = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 16px;

	@media (max-width: 992px) {
		display: flex;
		flex-direction: column;
	}
`;

export const ButtonRow = styled.div`
	display: flex;
	gap: 8px;
	margin-top: 32px;
`;

export const TableSwitchButton = styled.button<{ $isActive: boolean; $isNoCursor?: boolean; $round?: boolean }>`
	padding: 8px 12px;
	font-size: 20px;
	line-height: 27px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.transparent.light45};
	cursor: pointer;
	border-radius: ${props => (props.$round ? '12px' : '4px')};

	${({ $isActive }) =>
		$isActive &&
		css`
			color: ${({ theme }) => theme.colors.text.alwaysWhite};
			background-color: ${({ theme }) => theme.colors.transparent.light10};
		`}

	${({ $isNoCursor }) =>
		$isNoCursor &&
		css`
			cursor: default;
		`}
`;
